/* eslint-disable no-unused-vars */

// 🤖 🤖 🤖 Value of enum must align with the voice_vector_product_pricing DynamoDb table
export enum SubscriptionType {
  UNLIMITED_SPEECH_TO_TEXT = 'unlimited_speech_to_text',
  UNLIMITED_VOICE_CLONE_AND_TEXT_TO_SPEECH = 'unlimited_voice_clone_and_text_to_speech',
}
